import React, {useState, useEffect} from "react";
import {TitleCustom} from "../../components/TitleCustom/TitleCustom";
import Margin from "canvas-core-react/lib/Margin";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextBody from "canvas-core-react/lib/TextBody";
import Card from "canvas-core-react/lib/Card";
import TextCaption from "canvas-core-react/lib/TextCaption";
import Checkbox from "canvas-core-react/lib/Checkbox";
import {Biometric} from "./biometric/Biometric";
import iconSelectOption from "../../assets/images/icon-select-option.svg";
import {PrimaryButtonCustom} from "../../components/PrimaryButtonCustom/PrimaryButtonCustom";
import useIsMobile from "../../hooks/useIsMobile";
import {SecondaryButtonCustom} from "../../components/SecondaryButtonCustom/SecondaryButtonCustom";
import {useAppContext} from "../../context/AppContext";
import { WealthService } from "../../services";
import { RetryErrorComponent } from "../../components";

export const StepSelectValidationOptions = () => {
    const {state: context, changeItem, displayError} = useAppContext();
    const {validationCheck} = context;
    /*methods componente*/
    const isMobile = useIsMobile();
    const [checked, setChecked] = useState(false);
    const [consent, setConsent] = useState({
        auth_type: "",
        consent_text: "Cargando...",
        creation_time: "",
        is_active: "",
        sign_provider: "",
        version: "",
      });

    const wealthService = new WealthService();

    const getConsent = () => {
        changeItem({ loading: true });
        wealthService
          .consent({
            channel: "WPUB",
            product: "WEALTH",
            flowType: "ONBOARDING_WEALTH_CUSTOMER",
            consentType: "ESPECIFICO",
            productName: "BIOMETRIC_VALIDATION",
          })
          .then((res) => {
            let value = res;
            let row = value[0];
            setConsent({
              auth_type: row.auth_type,
              consent_text: row.consent_text,
              creation_time: row.creation_time,
              is_active: row.is_active,
              sign_provider: row.sign_provider,
              version: row.version,
            });
          })
          .catch((error) => {
            displayError(
              error,
              getConsent,
              <RetryErrorComponent retryCallBack={getConsent} />
            );
          })
          .finally(() => {
            changeItem({ loading: false });
          });
      };

    useEffect(() => {
        getConsent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    const saveConsent = async () => {
        await wealthService
          .consentSave({
            customer_id: context.subjectData.rut,
            customer_ip: "",
            channel_type: "WPUB",
            product_type: "WEALTH",
            flow_type: "ONBOARDING_WEALTH_CUSTOMER",
            consent_type: "ESPECIFICO",
            product_name: "BIOMETRIC_VALIDATION",
            version: consent.version,
          })
          .then((res) => {
            changeItem({validationCheck: true})
          })
          .catch((error) => {
            displayError(error, saveConsent);
          });
      };

    const continueNextStep = () => {
        saveConsent()
    }

    const ButtonPrimaryComponent = () => (
        <PrimaryButtonCustom
            id="navigation-continuar-button"
            name="navigation-continuar-button"
            text="Continuar"
            disabled={!checked}
            onClick={continueNextStep}
        />
    );
    if (!validationCheck) {
        return (
            <React.Fragment key="selectValidationOptions">
                <TitleCustom
                    image={<img src={iconSelectOption} alt="loading scan"/>}
                    text="¡Ya estás en nuestros registros. !"
                />
                <Margin id="infoText" xs={18}>
                    <Row className="align-items--center">
                        <Column>
                            <TextBody component="p" type="1">
                                Por tu seguridad, debes continuar con la siguiente alternativa para validar tus datos
                            </TextBody>
                        </Column>
                    </Row>
                </Margin>
                <Margin id="CardRadioButtons" xs={36}>
                    <Row>
                        <Column>
                            <Card
                                className="Card__container"
                                lgPadding={36}
                                mdPadding={18}
                                smPadding={18}
                                xsPadding={18}
                            >
                                <div className="Div_container_radioButton">
                                    <TextCaption component="p" bold>
                                        Validación biométrica
                                    </TextCaption>
                                    <br/>
                                    <TextCaption component="span">
                                        Es un sistema que comprueba tu identidad a través de
                                        características faciales y con cédula de identidad.
                                    </TextCaption>
                                </div>
                            </Card>
                        </Column>
                    </Row>
                </Margin>
                <Margin id="CheckBiometric" xs={[36, 0, 0, 0]}>
                    <Row>
                        <Column>
                            <Checkbox
                                id="check_authorization"
                                name="check_authorization"
                                value="checkSuccess"
                                checked={checked}
                                onChange={() => setChecked(!checked)}
                                label={
                                    <TextBody component="span">
                                        {consent.consent_text}
                                    </TextBody>
                                }
                            />
                        </Column>
                    </Row>
                </Margin>
                <Margin id="ButtonsWizard" xs={36}>
                    <Row className="align-items--center">
                        <Column lg={3} xs={4}>
                            <Margin xs={[0, 0, 12, 0]}>
                                {isMobile ? (
                                    <ButtonPrimaryComponent/>
                                ) : (
                                    <SecondaryButtonCustom
                                        id="navigation-volver-button"
                                        onClick={() => changeItem({clientStep: "stepRut"})}
                                        text="Volver"
                                    />
                                )}
                            </Margin>
                        </Column>
                        <Column lg={3} lgOffset={6} xs={4}>
                            <Margin xs={[0, 0, 12, 0]}>
                                {isMobile ? (
                                    <SecondaryButtonCustom
                                        id="navigation-volver-button"
                                        onClick={() => changeItem({clientStep: 'stepRut'})}
                                        text="Volver"
                                    />
                                ) : (
                                    <ButtonPrimaryComponent/>
                                )}
                            </Margin>
                        </Column>
                    </Row>
                </Margin>
            </React.Fragment>
        );
    } else {
        return <Biometric/>;
    }
};